import { featureMag } from "@/mocks/jiukanliao";
import SectionHeading from "./SectionHeading";

export default function FeatureSection() {
  return (
    <section id="feature" className="bg-[#fff9f0] py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <SectionHeading
          eyebrow="编辑部专栏 · 图文并重"
          title="看图吃瓜，也有方法论"
          desc="多图预警不代表一图胜千言。我们把散落的截图按顺序、视角与时间重新编排，图文并重，讲清同一件事为什么“图一多就反转”。"
          align="center"
        />
        <div className="mx-auto mt-4 max-w-2xl text-center text-sm text-[#a48a5d]">
          先看九格顺序 · 再看关键帧 · 最后比对时间戳
        </div>

        <div className="mt-12 flex flex-col gap-10">
          {featureMag.map((m, i) => (
            <article
              key={m.title}
              className="grid grid-cols-1 items-center gap-6 lg:grid-cols-2 lg:gap-12"
            >
              <a
                href="#faq"
                className={`group relative block overflow-hidden rounded-3xl ${
                  i % 2 === 1 ? "lg:order-2" : ""
                }`}
              >
                <div className="aspect-[16/10] w-full overflow-hidden">
                  <img
                    src={m.image}
                    alt={m.title}
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                  />
                </div>
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-[#fff6e6]/90 px-3 py-1 text-xs font-semibold text-[#a86a1f]">
                  <i className="ri-book-open-line" />
                  {m.kicker}
                </span>
              </a>
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <h3 className="font-display text-2xl font-black leading-snug text-[#231f18] md:text-3xl">
                  {m.title}
                </h3>
                <p className="mt-4 text-[15px] leading-8 text-[#6b5f48]">{m.summary}</p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <a
                    href="#faq"
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-[#d9431f] px-5 py-2.5 text-[13px] font-semibold text-white transition hover:bg-[#b83516]"
                  >
                    阅读本期专题
                    <i className="ri-arrow-right-line" />
                  </a>
                  <span className="text-xs text-[#a48a5d]">约 8 分钟读完 · 配 27 张图</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}